/**
 * Checks if string ends with '/' symbol
 */
export function hasTrailingSlash(str: string): boolean {
  return str.endsWith('/');
}

/**
 * Checks if string starts with '/' symbol and remove it in case it is
 */
export function trimLeadingSlash(str: string): string {
  return str.startsWith('/') ? str.slice(1) : str;
}
